import { Component, Input } from '@angular/core';
import { LiquidityIcon } from '../../models/sell.models';

@Component({
  selector: 'pla-plate-x-liquidity-card',
  templateUrl: './plate-x-liquidity-card.component.html',
  styleUrls: ['./plate-x-liquidity-card.component.scss'],
})
export class PlateXLiquidityCardComponent {
  @Input() icon: LiquidityIcon = 'readability';
  @Input() title: string = '';
  @Input() body: string = '';
}
